import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CarteraService } from 'app/services/cartera/cartera.service';

@Component({
  selector: 'app-tipo-factura',
  templateUrl: './tipo-factura.component.html',
  styleUrls: ['./tipo-factura.component.scss']
})
export class TipoFacturaComponent implements OnInit {

  public factura_elect: string;
  public factura_fisic: string;

  /**
   * Constructor
   * 
   * @param _data 
   * @param {MatDialogRef<TipoFacturaComponent>} _dialog 
   * @param {MatSnackBar} _snackBar 
   * @param {CarteraService} _cartera 
   */
  constructor
  (
    @Inject(MAT_DIALOG_DATA) private _data, 
    private _dialog: MatDialogRef<TipoFacturaComponent>, 
    private _snackBar: MatSnackBar, 
    private _cartera: CarteraService
  ) 
  {
    this.factura_elect = _data.factura_elec;
    this.factura_fisic= _data.factura_fis;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {}

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Guarda los tipos de facturas seleccionadas
   */
  public guardarTipoFactura(){
    this._cartera.GuardarTipoFactura(this.factura_fisic, this.factura_elect, this._data.codigo, this._data.codigo, this._data.empresa).subscribe((data: any) => {
      if(data.affectedRows == 1){
        this._snackBar.open('Tipo de factura actualizado', 'Aceptar', {
          duration: 2000
        });
        this._dialog.close(true);
      }else{
        this._snackBar.open('Error al actualizar el tipo de factura.', '', {
          panelClass: ['warn-600'],
          duration: 2000
        });
      }
    });
  }
}                             
